import { isInViewportArea, showFromFade } from "../../js/Util";

App.D.ready(() => {
    if (App.H.hasClass("page-about") && !App.H.hasClass("page-about-tumodo")) {
        App.H.removeClass("_noscroll");
        window.scrollTo(0, 0);
        App.W.scrollTop(0);
        $("html, body").animate({ scrollTop: 0 }, 100);
        setTimeout(() => {
            window.scrollTo(0, 0);
            App.W.scrollTop(0);
            $("html, body").animate({ scrollTop: 0 }, 50);
        }, 100);
        setTimeout(() => {
            App.H.addClass("_noscroll");
        }, 150);
    }

    if (
        $(".about-animation__image").length &&
        !App.H.hasClass("page-about-tumodo")
    ) {
        let lottieAnimation = document.querySelector("#about-lottie");

        $(".about-animation__image").css("transform", `rotate(0deg)`);

        setTimeout(() => {
            $(".about-animation").removeClass("_start");
        }, 3500);

        lottieAnimation.addEventListener("load", () => {
            $(".about-start").addClass("_lottie-loaded");
        });
        lottieAnimation.addEventListener("complete", () => {
            App.H.removeClass("_noscroll");
            $('body').unbind('touchmove');
            $(".about-start").addClass("_logo-shown");
            $(".about-animation").addClass("_finished");

        });

        let lastScrollTop = -1;

        const scrollAbout = () => {
            let pageHeight = $(".js-about-cards").innerHeight();
            let windowScrollTop = App.W.scrollTop();

            if (windowScrollTop < 0) windowScrollTop = 0;
            if (lastScrollTop < 0) lastScrollTop = 0;

            if (pageHeight < 1500) {
                pageHeight = 3000;
            }
            $(".about-animation._finished .about-animation__image").css(
                "transform",
                `rotate(${(windowScrollTop / pageHeight) * 360}deg)`
            );

            lastScrollTop = windowScrollTop;
        };

        App.W.on("scroll", scrollAbout);
    }

    if ($(".js-about-cards-item").length) {
        const aboutCardsScroll = () => {
            $(".js-about-cards-item").each((ind, item) => {
                if (isInViewportArea(item, 0.5)) {
                    $(item).removeClass("_hidden");
                }
            });
        };
        App.W.on("scroll", aboutCardsScroll);
    }

    if ($(".about-block").length) {
        $(".about-block").each((index, item) => {
            if (!$(item).hasClass('_no-scroll-animation') && !$(item).closest('._no-scroll-animation')) {
                const start =
                    $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
                showFromFade(item, start);
            }
        });
    }
    if ($(".advantages-slider:not(.advantages-slider-adv)").length) {
        $(".advantages-slider:not(.advantages-slider-adv)").each((index, item) => {
            if (!$(item).hasClass('_no-scroll-animation') && !$(item).closest('._no-scroll-animation')) {
                const start =
                    $(document).width() >= 768 ? "top bottom-=20%" : "top bottom-=10%";
                showFromFade(item, start);
            }
        });
    }
});